module.exports = __webpack_public_path__ + "img/Airbnb-Office-Everyday-Stretches-Wrist.73837f25.jpg";